export const agentPlayground = {
  header: {
    title: "Pruebas del Agente IA",
    chip: "Recepción IA · Beta",
    sub: "Conversa con el agente avanzado sin enviar nada por WhatsApp.",
  },
  context: {
    title: "Contexto",
    listingLabel: "Anuncio",
    listingPlaceholder: "Selecciona un anuncio…",
    allListings: "🌐 Todos los alojamientos (nuevas reservas)",
    accountModeHint:
      "El agente atiende como si no estuviera atado a un alojamiento: ideal para probar solicitudes de reserva.",
    guestStatusLabel: "Estado del huésped",
    stay: {
      auto: "Automático",
      inStay: "Hospedado ahora (en la estancia)",
      beforeArrival: "Aún no ha llegado (reserva futura)",
      after: "Estancia finalizada",
    },
    guestStatusHint: "Simula el momento del huésped para ver las distintas respuestas.",
    reservationIdLabel: "ID de reserva",
    optional: "(opcional)",
    reservationIdPlaceholder: "Ej: 1234",
    phoneLabel: "Teléfono del huésped",
    phonePlaceholder: "+34...",
    langLabel: "Idioma",
    lang: {
      auto: "Automático",
      es: "Español",
      en: "Inglés",
      pt: "Portugués",
      fr: "Francés",
      de: "Alemán",
      pl: "Polaco",
    },
    reset: "Reiniciar conversación",
  },
  debug: {
    resolvedTitle: "Contexto resuelto",
    listing: "Listing",
    property: "Propiedad",
    reservation: "Reserva",
    checkin: "Entrada",
    checkout: "Salida",
    lang: "Idioma",
    toolsTitle: "Herramientas usadas",
  },
  chat: {
    emptyPrompt: "Escribe un mensaje como si fueras el huésped.",
    pay: "Pagar",
    book: "Reservar",
    sentAsButton: "En WhatsApp se envía como botón",
    sentAsList: "En WhatsApp se envía como lista · {button}",
    inputPlaceholder: "Escribe un mensaje…",
  },
  suggestions: {
    s1: "¿A qué hora es el check-in?",
    s2: "¿Hay parking?",
    s3: "¿Tenéis wifi? ¿Cuál es la contraseña?",
    s4: "Can I check in early?",
  },
  errors: {
    loadListings: "No se pudieron cargar los anuncios.",
    chatError: "Error al hablar con el agente.",
    chatReplyFallback: "⚠️ No pude responder. Revisa el contexto o vuelve a intentarlo.",
  },
  methods: {
    listingFallback: "Anuncio #{id}",
  },
};
